import React, { useState, useEffect } from "react";
import axios from "axios";

const MyCourseWebLinks = ({ platformUrl }) => {
    const [webLinks, setWebLinks] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);

    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const courseUuid = params.get("courseUuid");

    useEffect(() => {
        if (!token || !courseUuid) {
            setError("Missing access token or course UUID. Please try again.");
            setLoading(false);
            return;
        }

        const fetchWebLinks = async () => {
            try {
                const response = await axios.get(
                    `${platformUrl}/learn/api/public/v1/courses/uuid:${courseUuid}/contents?parentId=ROOT`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );

                const contents = response.data.results || [];
                const webLinksOnly = contents.filter(
                    (item) => item.contentHandler?.id === "resource/x-bb-externallink"
                );

                setWebLinks(webLinksOnly);
            } catch (err) {
                setError(err.message);
            } finally {
                setLoading(false);
            }
        };

        fetchWebLinks();
    }, [platformUrl, courseUuid, token]);

    if (loading) {
        return <div>Loading web links...</div>;
    }

    if (error) {
        return (
            <div className="bb-container bb-error">
                <h1 className="bb-title">Error</h1>
                <p>{error}</p>
                <p>Please check your access token or course UUID and try again.</p>
            </div>
        );
    }

    return (
        <div className="bb-container">
            <h1 className="bb-title">Course Web Links</h1>
            {webLinks.length === 0 ? (
                <p>No web links found in this course.</p>
            ) : (
                <table className="bb-table">
                    <thead>
                    <tr>
                        <th>Title</th>
                        <th>URL</th>
                    </tr>
                    </thead>
                    <tbody>
                    {webLinks.map((link) => (
                        <tr key={link.id}>
                            <td>{link.title}</td>
                            <td>
                                <a href={link.contentHandler?.url} target="_blank" rel="noopener noreferrer">
                                    {link.contentHandler?.url}
                                </a>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default MyCourseWebLinks;
